import { Instagram, Facebook, Youtube, Linkedin, Globe } from "lucide-react";

// lucide has no TikTok or X marks, so those two are drawn inline.
function TikTokIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 1 1-2.59-2.59c.27 0 .53.04.77.12V9.76a5.7 5.7 0 0 0-.77-.05 5.69 5.69 0 1 0 5.69 5.69V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.28 4.28 0 0 1-3.25-1.48Z" />
    </svg>
  );
}

function XIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      <path d="M17.75 3h3.07l-6.7 7.66L22 21h-6.17l-4.83-6.32L5.47 21H2.4l7.17-8.2L2 3h6.33l4.37 5.78L17.75 3Zm-1.08 16.18h1.7L7.4 4.73H5.58l11.09 14.45Z" />
    </svg>
  );
}

export const SOCIAL_NETWORKS = [
  { key: "instagram", label: "Instagram", placeholder: "@yourhandle", Icon: Instagram },
  { key: "facebook", label: "Facebook", placeholder: "facebook.com/yourpage", Icon: Facebook },
  { key: "tiktok", label: "TikTok", placeholder: "@yourhandle", Icon: TikTokIcon },
  { key: "x", label: "X (Twitter)", placeholder: "@yourhandle", Icon: XIcon },
  { key: "youtube", label: "YouTube", placeholder: "@yourchannel", Icon: Youtube },
  { key: "linkedin", label: "LinkedIn", placeholder: "linkedin.com/in/yourname", Icon: Linkedin },
  { key: "website", label: "Website", placeholder: "yourwebsite.com", Icon: Globe },
];

const isWebLink = (url) => /^https?:\/\//i.test(url || "");

export function hasSocialLinks(links) {
  return SOCIAL_NETWORKS.some(({ key }) => isWebLink(links?.[key]));
}

export default function SocialLinks({ links, className = "" }) {
  const items = SOCIAL_NETWORKS.filter(({ key }) => isWebLink(links?.[key]));
  if (!items.length) return null;

  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {items.map(({ key, label, Icon }) => (
        <a
          key={key}
          href={links[key]}
          target="_blank"
          rel="noopener noreferrer nofollow"
          aria-label={label}
          title={label}
          className="flex h-9 w-9 items-center justify-center rounded-full border border-border text-slate-700 transition-colors hover:border-primary hover:text-primary"
        >
          <Icon className="h-4 w-4" />
        </a>
      ))}
    </div>
  );
}
